/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast, no-nested-ternary */

import { Button, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import PieChart from '@components/home/assignedContent/progressPie/pieChart';
import { PlayArrowIcon } from '../../../uiLibraryImports';
import { CourseBannerProps } from '../../learn/courseBanner/courseBannerTypes';
import styles from './courseTop.module.scss';

const CourseTop: FC<CourseBannerProps> = (props: CourseBannerProps) => {
    const {
        name,
        displayName,
        description,
        coins,
        courseImage,
        completionRate,
        playNextLessonUrl,
        navigateCoursePageUrl
    } = props;

    return (
        <div>
            <div className={styles['course-banner']}>
                <a
                    id={`course-banner-${name}`}
                    data-testid="course-banner"
                    className={styles['course-banner']}
                    href={navigateCoursePageUrl}
                >
                    <div className={styles['inner-wrapper']}>
                        <div className={styles['left-side']}>
                            <div className={styles['top-wrapper']}>
                                <Icon name={'courseBannerIcon'} className={styles['top-icon']} />
                                <div className={styles.text}>{translate('COURSE')}</div>
                            </div>
                            <div className={styles['name-wrapper']}>
                                <div className={styles.name} title={translate(displayName)}>
                                    {translate(displayName)}
                                </div>
                            </div>
                            <div className={styles.description} title={translate(description)}>
                                {translate(description)}
                            </div>
                            <div>
                                <div className={styles['button-wrapper']}>
                                    {playNextLessonUrl && (
                                        <a href={playNextLessonUrl}>
                                            <Button
                                                type={'bigGradient'}
                                                text={translate('PlayNextLesson')}
                                                className={styles.button}
                                                startIcon={<PlayArrowIcon />}
                                                lowerCase
                                            />
                                        </a>
                                    )}
                                    {completionRate !== 0 && completionRate && (
                                        <div className={styles['completion-rate-wrapper']}>
                                            <PieChart percentage={Math.trunc(completionRate)} position="relative" />
                                            {coins !== 0 && coins && <hr />}
                                        </div>
                                    )}
                                    <div className={styles['score-wrapper']}>
                                        {coins !== 0 && coins && (
                                            <div className={styles['earned-points']}>
                                                {translate('Earned')}
                                                <Icon name="devCoin" />
                                                <div className={styles.score}>{coins}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src={courseImage} alt="course" className={styles['course-background']} />
                    </div>
                </a>
            </div>
        </div>
    );
};

export default CourseTop;
